var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioEnable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.57031,
    width: 43,
    height: 43,
    rx: 21.5,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 25.9009C24.059 25.9009 25.3249 24.5411 25.3249 22.8663V17.1049C25.3249 15.4302 24.059 14.0703 22.5 14.0703C20.941 14.0703 19.6751 15.4302 19.6751 17.1049V22.8663C19.6751 24.5411 20.941 25.9009 22.5 25.9009ZM26.3442 20.848V22.8735C26.3442 24.0186 25.9178 25.0421 25.2183 25.7936C24.5187 26.5451 23.566 27.0031 22.5 27.0031C21.434 27.0031 20.4813 26.5451 19.7817 25.7936C19.0888 25.0421 18.6558 24.0186 18.6558 22.8735V20.848H17.25V22.8735C17.25 25.7363 19.2287 28.0981 21.8004 28.4632V30.5602H19.4952V32.0703H25.5114V30.5602H23.2062V28.4632C25.7713 28.091 27.75 25.7363 27.75 22.8735V20.848H26.3442Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioEnable);
export default __webpack_public_path__ + "static/media/audioEnable.7d55b7d22c70552be6f1233ceca7a9fd.svg";
export { ForwardRef as ReactComponent };